import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {withStyles} from 'material-ui/styles/index';
import SwipeableViews from 'react-swipeable-views';
import Tabs, {Tab} from 'material-ui/Tabs/index';
import CardLayout from "components/CardLayout";
import CardMenu from "components/dashboard/Common/CardMenu";
import {products} from "app/routes/dashboard/routes/ECommerce/data";
import {urlPrefix, get} from 'engine/dataServices';
import ProductTab from './productTab';


function TabContainer({children, dir}) {
    return (
        <div style={{overflowX: 'hidden'}} dir={dir}>
            {children}
        </div>
    );
}

TabContainer.propTypes = {
    children: PropTypes.node.isRequired,
    dir: PropTypes.string.isRequired,
};

class FavoriteProducts extends Component {

    handleChange = (event, value) => {
        this.setState({value});
    };

    handleChangeIndex = index => {
        this.setState({value: index});
    };


    constructor() {
        super();
        this.state = {
            value: 0,
            topSalesData: [],
            topLikesData: [],
            topCommentsData: [],
            noStocksData: []
        }
    }

    componentWillMount() {
        this.loadTopSales();
        this.loadTopLikes();
        this.loadTopComments();
        this.loadNoStocks();
    }

    async loadTopSales() {
        const res = await get('Product/GetTopSales');
        if (res.status == 200) {
            const responseData = await res.json();
            let _data = [];
            responseData.map(x => {
                _data.push({
                    image: urlPrefix + x.Image,
                    title: x.Name,
                    description: x.Description,
                    note: `مبلغ ${x.Count.toLocaleString()} تومان فروخته شده`
                });
            });
            this.setState({topSalesData: _data});
        }
    }

    async loadTopLikes() {
        const res = await get('Product/GetTopLikes');
        if (res.status == 200) {
            const responseData = await res.json();
            let _data = [];
            responseData.map(x => {
                _data.push({
                    image: urlPrefix + x.Image,
                    title: x.Name,
                    description: x.Description,
                    note: `تعداد ${x.Count.toLocaleString()} لایک`
                });
            });
            this.setState({topLikesData: _data});
        }
    }

    async loadTopComments(){
        const res = await get('Product/GetTopComments');
        if (res.status == 200) {
            const responseData = await res.json();
            let _data = [];
            responseData.map(x => {
                _data.push({
                    image: urlPrefix + x.Image,
                    title: x.Name,
                    description: x.Description,
                    note: `تعداد ${x.Count.toLocaleString()} نظر`
                });
            });
            this.setState({topCommentsData: _data});
        }
    }

    async loadNoStocks(){
        const res = await get('Product/GetNoStocks');
        if (res.status == 200) {
            const responseData = await res.json();
            let _data = [];
            responseData.map(x => {
                _data.push({
                    image: urlPrefix + x.Image,
                    title: x.Name,
                    description: x.Description,
                    note: `${x.Count.toLocaleString()}عدد موجود در انبار`
                });
            });
            this.setState({noStocksData: _data});
        }
    }



    render() {
        const {theme} = this.props;
        const {topSalesData, topLikesData, topCommentsData, noStocksData} = this.state;

        return (
            <CardLayout styleName="col-lg-12">
                <div className="jr-card-header mb-3 d-flex align-items-center">
                    <div>
                        <h3 className="card-heading mb-0">
                            <i className="zmdi zmdi-widgets ml-2"/>
                            محصولات برتر
                        </h3>
                    </div>
                </div>

                <div className="tab-notifications">
                    <Tabs
                        value={this.state.value}
                        onChange={this.handleChange}
                        indicatorColor="primary"
                        textColor="primary"
                        centered
                        fullWidth
                    >
                        <Tab className="tab" label="بیشترین فروش"/>

                        <Tab className="tab" label="بیشترین لایک"/>

                        <Tab className="tab" label="بیشترین نظرات"/>

                        <Tab className="tab" label="کمترین موجودی"/>
                    </Tabs>
                </div>

                <SwipeableViews
                    axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                    index={this.state.value}
                    onChangeIndex={this.handleChangeIndex}
                >
                    <TabContainer dir={theme.direction}>
                        <div className="row" style={{paddingTop: 20}}>
                            {topSalesData.map((product, index) => <ProductTab key={index} product={product}/>)}
                        </div>
                    </TabContainer>
                    <TabContainer dir={theme.direction}>
                        <div className="row" style={{paddingTop: 20}}>
                            {topLikesData.map((product, index) => <ProductTab key={index} product={product}/>)}
                        </div>
                    </TabContainer>
                    <TabContainer dir={theme.direction}>
                        <div className="row" style={{paddingTop: 20}}>
                            {topCommentsData.map((product, index) => <ProductTab key={index} product={product}/>)}
                        </div>
                    </TabContainer>
                    <TabContainer dir={theme.direction}>
                        <div className="row" style={{paddingTop: 20}}>
                            {noStocksData.map((product, index) => <ProductTab key={index} product={product}/>)}
                        </div>
                    </TabContainer>
                </SwipeableViews>
            </CardLayout>

        );
    }
}

FavoriteProducts.propTypes = {
    theme: PropTypes.object.isRequired,
};

export default withStyles(null, {withTheme: true})(FavoriteProducts);


// WEBPACK FOOTER //
// ./components/toliton/desktop/products/favoriteProducts.js